var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUserStar(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14 6C14 8.20914 12.2091 10 10 10C7.79086 10 6 8.20914 6 6C6 3.79086 7.79086 2 10 2C12.2091 2 14 3.79086 14 6Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M16.6012 12.2725C16.7538 11.9092 17.2462 11.9092 17.3988 12.2725L18.5085 14.9146C18.5718 15.0651 18.7075 15.1684 18.8638 15.1848L21.6073 15.4731C21.9845 15.5127 22.1367 16.0029 21.8538 16.2671L19.7961 18.1884C19.6789 18.2978 19.6271 18.4648 19.6604 18.6255L20.2463 21.4458C20.3268 21.8336 19.9285 22.1366 19.601 21.9366L17.2196 20.4818C17.1517 20.4404 17.0759 20.4197 17 20.4197C16.9241 20.4197 16.8483 20.4404 16.7804 20.4818L14.399 21.9366C14.0715 22.1366 13.6732 21.8336 13.7537 21.4458L14.3396 18.6255C14.3729 18.4648 14.3211 18.2978 14.2039 18.1884L12.1462 16.2671C11.8633 16.0029 12.0155 15.5127 12.3927 15.4731L15.1362 15.1848C15.2925 15.1684 15.4282 15.0651 15.4915 14.9146L16.6012 12.2725Z",
    fill: "currentColor"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M15.0887 12H4C2.89543 12 2 12.8954 2 14C2 18.4183 5.58172 22 10 22C10.7823 22 11.5384 21.8877 12.253 21.6784C12.2382 21.5012 12.2478 21.3205 12.2851 21.1408L12.7534 18.8862L11.1225 17.3635C9.97834 16.2952 10.4737 14.1665 12.2359 13.9813L14.3498 13.7592L15.0887 12Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUserStar);
export default __webpack_public_path__ + "static/media/user-star.549566cad6e8b3b6f2ca8e64ace21dd0.svg";
export { ForwardRef as ReactComponent };